/** 낭만궁합 > 서브 목차 */
export const CONTENTS = [
  { id: 1, title: '1. 궁합 종합 분석' },
  { id: 2, title: '2. 지표 상세 분석' },
  { id: 3, title: '3. 종합 조언' },
  { id: 4, title: '' },
];

/** 낭만궁합 > 페이지네이션 > 메인 목차 인덱스 - 페이지 매칭 */
export const CONTENTS_PAGE_MAP = {
  0: 1,
  1: 2,
  2: 3,
  3: 4,
};

/** 카테고리별 일러스트 이미지 */
const loverImages = import.meta.glob('@manseImages/harmony/lover/*.png', {
  eager: true,
  import: 'default',
});
const friendImages = import.meta.glob('@manseImages/harmony/friend/*.png', {
  eager: true,
  import: 'default',
});
const businessImages = import.meta.glob('@manseImages/harmony/business/*.png', {
  eager: true,
  import: 'default',
});
const familyImages = import.meta.glob('@manseImages/harmony/family/*.png', {
  eager: true,
  import: 'default',
});

export const HARMONY_CATEGORY_IMAGES = {
  lover: Object.values(loverImages),
  friend: Object.values(friendImages),
  business: Object.values(businessImages),
  family: Object.values(familyImages),
};

/** 카테고리 ID로 랜덤 이미지 반환 */
export const getRandomCategoryImage = (categoryId) => {
  const images = HARMONY_CATEGORY_IMAGES[categoryId];
  if (!images?.length) return null;
  const idx = Math.floor(Math.random() * images.length);
  return images[idx];
};

/** 문자열 키 기반 결정적 카테고리 이미지 반환 */
export const getCategoryImageByKey = (categoryId, key) => {
  const images = HARMONY_CATEGORY_IMAGES[categoryId];
  if (!images?.length) return null;
  const str = String(key ?? '');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(hash) % images.length;
  return images[idx];
};

/** 오행 색상 매핑 (Figma 디자인 기준) */
export const OHENG_COLORS = {
  목: { border: '#5E9F1C', text: '#5E9F1C', bg: '#F0F8F0' },
  화: { border: '#C23535', text: '#C23535', bg: '#FDF0F0' },
  토: { border: '#DB9823', text: '#DB9823', bg: '#FDF8F0' },
  금: { border: '#949494', text: '#949494', bg: '#F5F5F5' },
  수: { border: '#404040', text: '#404040', bg: '#F0F0F0' },
};

/** 오행 한자 매핑 */
export const OHENG_HANJA = {
  목: '木',
  화: '火',
  토: '土',
  금: '金',
  수: '水',
};

/** 관계 타입 */
export const RELATION_TYPES = {
  saeng: { label: '생(生)', color: '#4E80D6', lineStyle: 'solid' },
  geuk: { label: '극(剋)', color: '#FF6B6B', lineStyle: 'dashed' },
  bigyeon: { label: '비견', color: '#949494', lineStyle: 'solid' },
};

/** 나이대 → 폴더 키 변환 */
export const getAgeGroup = (age) => {
  const ageStr = String(age ?? '');
  const manMatch = ageStr.match(/만\s*(\d+)/);
  const numAge = manMatch ? parseInt(manMatch[1], 10) : parseInt(ageStr, 10);
  if (isNaN(numAge) || numAge >= 70) return '60s';
  if (numAge < 20) return '10s';
  if (numAge < 30) return '20s';
  if (numAge < 40) return '30s';
  if (numAge < 50) return '40s';
  return '50s';
};

/** 캐릭터 이미지 (성별 + 나이대 기반) */
const maleCharacters = {
  '10s': Object.values(
    import.meta.glob('@manseImages/harmony/character/male/10s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '20s': Object.values(
    import.meta.glob('@manseImages/harmony/character/male/20s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '30s': Object.values(
    import.meta.glob('@manseImages/harmony/character/male/30s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '40s': Object.values(
    import.meta.glob('@manseImages/harmony/character/male/40s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '50s': Object.values(
    import.meta.glob('@manseImages/harmony/character/male/50s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '60s': Object.values(
    import.meta.glob('@manseImages/harmony/character/male/60s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
};
const femaleCharacters = {
  '10s': Object.values(
    import.meta.glob('@manseImages/harmony/character/female/10s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '20s': Object.values(
    import.meta.glob('@manseImages/harmony/character/female/20s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '30s': Object.values(
    import.meta.glob('@manseImages/harmony/character/female/30s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '40s': Object.values(
    import.meta.glob('@manseImages/harmony/character/female/40s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '50s': Object.values(
    import.meta.glob('@manseImages/harmony/character/female/50s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
  '60s': Object.values(
    import.meta.glob('@manseImages/harmony/character/female/60s/*.png', {
      eager: true,
      import: 'default',
    }),
  ),
};

/** 성별 + 나이로 랜덤 캐릭터 이미지 반환 */
export const getRandomCharacterImage = (gender, age) => {
  const ageGroup = getAgeGroup(age);
  const pool = gender === '남' ? maleCharacters[ageGroup] : femaleCharacters[ageGroup];
  if (!pool?.length) return null;
  return pool[Math.floor(Math.random() * pool.length)];
};

const hashString = (key) => {
  const str = String(key ?? '');
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

/** 성별 + 나이 + 키(이름/생년월일 등) 기반 결정적 캐릭터 이미지 반환 */
export const getCharacterImageByKey = (gender, age, key) => {
  const ageGroup = getAgeGroup(age);
  const pool = gender === '남' ? maleCharacters[ageGroup] : femaleCharacters[ageGroup];
  if (!pool?.length) return null;
  return pool[hashString(key) % pool.length];
};

/**
 * 여러 인원의 캐릭터 이미지를 결정적으로 선택하되, 같은 풀(동성+동연령대) 내에서
 * 중복이 생기면 다음 인덱스로 충돌을 피한다.
 * @param {Array<{gender: string, age: number|string, key: string}>} personInfos
 * @returns {Array<string|null>} 각 인원의 캐릭터 이미지 URL 배열
 */
export const getCharacterImagesForPersons = (personInfos = []) => {
  const usedByPool = new Map();
  return personInfos.map(({ gender, age, key }) => {
    const ageGroup = getAgeGroup(age);
    const pool = gender === '남' ? maleCharacters[ageGroup] : femaleCharacters[ageGroup];
    if (!pool?.length) return null;
    const poolId = `${gender === '남' ? 'M' : 'F'}-${ageGroup}`;
    const used = usedByPool.get(poolId) || new Set();
    let idx = hashString(key) % pool.length;
    if (used.size < pool.length) {
      while (used.has(idx)) {
        idx = (idx + 1) % pool.length;
      }
    }
    used.add(idx);
    usedByPool.set(poolId, used);
    return pool[idx];
  });
};

/**
 * 인원수별 원형 배치 좌표 (컨테이너 기준 %)
 * 나(index 0) = 상단, 시계방향
 */
export const LAYOUT_POSITIONS = {
  2: [
    { x: 20, y: 40 }, // 나 (왼쪽)
    { x: 80, y: 40 }, // 상대 (오른쪽)
  ],
  3: [
    { x: 50, y: 10 }, // 나 (상단 중앙)
    { x: 85, y: 70 }, // 우하
    { x: 15, y: 70 }, // 좌하
  ],
  4: [
    { x: 50, y: 10 }, // 나 (상단)
    { x: 87, y: 40 }, // 우측
    { x: 50, y: 80 }, // 하단
    { x: 13, y: 40 }, // 좌측
  ],
};
